var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline","color":"inherit"}},[_c('button',{staticClass:"btn btn-icon rounded-pill",staticStyle:{"color":"inherit"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.show.apply(null, arguments)}}},[_c('i',{staticClass:"icon-help icon-2x"})]),_vm._v(" "),_c('div',{staticClass:"nux-overlay-item",attrs:{"id":"nux-overlay"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2c0a0a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/help-icon.vue
// module id = 1964
// module chunks = 0